export enum ContributorType {
  Any = 'any',
  Contributor = 'contributor',
  Owner = 'owner',
  Viewer = 'viewer',
}

/**
 * `Any` is absent deliberately — it is a `role_access` wildcard, not a grant
 * somebody holds.
 */
export const WORK_CAPABLE_CONTRIBUTOR_TYPES: ContributorType[] = [
  ContributorType.Owner,
  ContributorType.Contributor,
];
